import React, { useState, useEffect, useContext } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import "./css/sampleGraph.css";
import Grid from "./images/ViewDashboard/grid.png";
import Select from "react-select";
import GraphContentsHover from "./GraphContentsHover";
import axios from "axios";
import { DBContext } from "./DBContext";

function SampleGraph() {
  const { logginedDB, sideNavState, sideNavStateFunc } = useContext(DBContext);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  const [salesData, setSalesData] = useState({
    labels: [],
    datasets: [],
  });
  const [monthSale, setMonthSale] = useState([]);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      width: "100%",
      fontSize: "0.881rem",
      fontFamily: "Nunito",
      backgroundColor: state.isSelected ? "#c8cbcf" : "#FFF",
      backgroundColor: state.isFocused ? "#c8cbcf" : "#FFF",
      color: state.isFocused ? "#000" : "#000",
      ":active": {
        ...provided[":active"],
        backgroundColor: "#c8cbcf",
      },
    }),
    input: (provided) => ({
      ...provided,
      // height: '2.5rem',
      width: "100% !important",
      fontSize: "0.881rem",
      fontFamily: "Nunito",
      cursor: "none",
      "&:hover": {
        cursor: "text",
      },
      "&:focus": {
        cursor: "default",
      },
      // display: 'none',
      color: "#2B3034",
    }),
    valueContainer: (provided) => ({
      ...provided,
      overflow: "hidden",
      fontSize: "0.881rem",
    }),
    indicatorSeparator: (provided, state) => ({
      ...provided,
      // display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      height: "2.5rem", // Adjust height of dropdown indicator to match control height
      marginTop: 0, // Adjust vertical alignment if needed
    }),
    control: (provided, state) => ({
      ...provided,
      width: "100% !important",
      height: "2.5rem",
      fontSize: "0.881rem",
      fontFamily: "Nunito",
      height: "2.5rem",
      border: "1px solid #D5D5D5",
      borderRadius: "0.313rem",
      textAlign: "left",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #C6C6C6",
      },
      "&:focus": {
        outline: "none", // Remove outline on focus
        cursor: "default", // Remove cursor on focus
      },
    }),
    placeholder: (provided, state) => ({
      ...provided,
      fontSize: "0.881rem",
      // lineHeight: '2.5rem',
    }),
    menu: (provided, state) => ({
      ...provided,
      fontSize: ".9rem",
      textAlign: "left",
      // height: '2.5rem',
    }),
  };

  const calender_options = [
    { value: "Jan", label: "January" },
    { value: "Feb", label: "February" },
    { value: "Mar", label: "March" },
    { value: "Apr", label: "April" },
    { value: "May", label: "May" },
    { value: "Jun", label: "June" },
    { value: "Jul", label: "July" },
    { value: "Aug", label: "August" },
    { value: "Sep", label: "September" },
    { value: "Oct", label: "October" },
    { value: "Nov", label: "November" },
    { value: "Dec", label: "December" },
  ];

  const [specificMonth, setSpecificMonth] = useState(false);
  const [diplayAllMonth, setDiplayAllMonth] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  // Function to handle select change
  const handleCalender = (selectedOption) => {
    setSelectedOption(selectedOption);
    setSpecificMonth(true);
    setDiplayAllMonth(false);
  };

  // Function to generate labels (days) array for a given month
  const generateDayLabelsForMonth = (selectedMonth) => {
    const index = data.labels.indexOf(selectedMonth);
    if (index !== -1) {
      const daysInMonth = new Date(
        new Date().getFullYear(),
        index + 1,
        0
      ).getDate();
      return Array.from({ length: daysInMonth }, (_, i) => `${i + 1}`);
    }
    return [];
  };

  //   ...........................................................GRAPH_CONTENTS..........................................................

  const formatMonth = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
    return `${year}-${month}`;
  };

  const formatYear = (date) => {
    return date.getFullYear().toString(); // "2025"
  };


  const [chartData, setChartData] = useState(null);

  // Click handler
  const handleGetSales = async (date = formatYear(new Date())) => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/TotalSalesBillByMonth/${logginedDB}`,
        { date }
      );

      if (response.status === 200) {
        const data = response.data;
        

        // Get the first (and only) year key dynamically
        const yearKey = Object.keys(data)[0];
        
        const sales = data[yearKey]; // Array of {month, totalBills, TotalAmount}

        // Prepare months array for chart
        const months = Array(12).fill(0);        

        sales.forEach((item) => {
          const monthIndex = parseInt(item.month, 10) - 1; // convert '03' → 2
          months[monthIndex] = item.TotalAmount; // OR item.totalBills depending on what you want
        });

        // ChartJS dataset
        const chartData = {
          labels: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          datasets: [
            {
              label: "Sales Details",
              data: months,
              // backgroundColor: "rgba(75, 192, 192, 0.5)",
              // borderColor: "rgba(75, 192, 192, 1)",
              // borderWidth: 1
              fill: true,
              borderColor: "#4379EE",
              backgroundColor: "#e8eefd",
              tension: 0.1,
            },
          ],
        };

      
        

        setSalesData({ ...chartData });
      }
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
  };


  function transformData(data) {
  // Month names aligned with your sampleData
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  // Initialize result object with empty arrays
  const result = {};
  months.forEach((m) => (result[m] = []));

  // Extract year → month → days
  Object.entries(data).forEach(([year, monthsObj]) => {
    Object.entries(monthsObj).forEach(([monthName, daysObj]) => {
      // Figure out how many days that month has
      const daysInMonth = new Date(parseInt(year), months.indexOf(monthName) + 1, 0).getDate();

      // Fill array with 0 initially
      const arr = new Array(daysInMonth).fill(0);

      // Fill values from backend
      Object.entries(daysObj).forEach(([day, { totalAmount }]) => {
        arr[parseInt(day) - 1] = totalAmount; // -1 because array index starts at 0
      });

      result[monthName] = arr;
    });
  });
  
  return [result]; 
}




    const handleGetSalesDate = async (date = formatYear(new Date())) => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/TotalSalesBillByDate/${logginedDB}`,
        { date }
      );

      if (response.status === 200) {
        const data = response.data;

       const result = transformData(data)
         setMonthSale(result);

      }
    } catch (error) {
      console.error("Error fetching sales data:", error);
    }
  };

  useEffect(() => {
    handleGetSalesDate(formatMonth(new Date())); // "YYYY-MM"
    handleGetSales(formatYear(new Date())); // sends "2025"
  }, []);

  const [hoveredData, setHoveredData] = React.useState(null);
  const data = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Sales Details",
        data: [
          10, 5000, 3000, 64000, 5000, 4000, 3000, 2000, 10000, 9000, 6000,
          7000,
        ],
        fill: true,
        borderColor: "#4379EE",
        backgroundColor: "#e8eefd",
        tension: 0.1,
      },
    ],
  };

  // Filtered data based on selected month
  let filteredData = {
    labels: [],
    datasets: [
      {
        ...salesData.datasets[0], // Keep other properties from original dataset
        salesData: [], // Initialize with empty data array
      },
    ],
  };

  if (specificMonth && selectedOption) {
    const selectedMonth = selectedOption.value;
    filteredData.labels = generateDayLabelsForMonth(selectedMonth);
    const index = data.labels.indexOf(selectedMonth);
    const month = selectedMonth;
    // //(selectedMonth);
    const sampleData = [
      {
        Jan: [
          0, 5000, 3000, 300, 5000, 4000, 3000, 2000, 10000, 9000, 6000, 5987,
          0, 5000, 3000, 400, 5000, 4000, 3000, 2000, 3999, 9000, 6000, 7000, 0,
          5000, 3000, 3040, 5000, 4000, 3000,
        ],
        Feb: [
          0, 5000, 3000, 300, 5000, 4000, 3000, 2000, 2777, 1000, 6000, 5987, 0,
          5000, 3000, 400, 5000, 4000, 3000, 2000, 3999, 9000, 6000, 7000, 0,
          5000, 3000, 3040, 5000, 4000, 3000,
        ],
        Mar: [0, 500, 399, 300, 23, 43, 45, 6, 800, 10, 321, 23],
        Apr: [],
        May: [],
        Jun: [],
        Jul: [],
        Aug: [],
        Sep: [],
        Oct: [],
        Nov: [],
        Dec: [],
      },
    ];
    if (index !== -1) {
      // filteredData.datasets[0].data = data.datasets[0].data.slice(index * 31, (index + 1) * 31);
      const monthData = monthSale[0][month];
      // // //(monthData);
      filteredData.datasets[0].data = monthData;
      filteredData.datasets[0].tension = 0.25;
    }
  }

  const handleHover = (event, chartElements) => {

    if (chartElements.length > 0) {
      const index = chartElements[0].index;
      const datasetIndex = chartElements[0].datasetIndex;
      let month;
      let day;
      let value;
      if (specificMonth && selectedOption) {
        month = selectedOption;
        // // //(filteredData.labels[index]);
        day = filteredData.labels[index];
        value = filteredData.datasets[datasetIndex].data[index];
      } else {
        month = salesData.labels[index];
        value = salesData.datasets[datasetIndex].data[index];
      }
      const text = salesData.datasets[datasetIndex].label;

      setHoveredData({ day, month, text, value });
    } else {
      setHoveredData(null);
    }
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat("en-IN", {
                style: "currency",
                currency: "INR",
              }).format(context.parsed.y); // Display tooltip value divided by 2
            }
            return label;
          },
        },
      },
    },
    onClick: handleHover,
    interaction: {
      mode: "index",
      intersect: true,
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            if (value === 0) {
              return value; // Display 0 as is
            } else if (value >= 1000) {
              return value / 1000 + "k"; // Divide by 2000 and display with 'k'
            } else if (value < 1000) {
              return value.toString();
            }
          },
        },
      },
    },
  };

  //   ...........................................................GRAPH_CONTENTS...........................................................

  const toDisplayAllMonths = () => {
    handleGetSales(formatYear(new Date()));
    setDiplayAllMonth(true);
    setSpecificMonth(false);
    setSelectedOption(null);
  };


  return (
    <div className="w-full flex gap-3">
      <div className="flex flex-col gap-2 w-3/4 p-3 bg-[#fff] shadow-[0px_0px_15px_rgba(0,0,0,0.1)] rounded-md">
        <div className="ChartSpanMonth">
          <span className="font-sans w-full text-[1.25rem] font-[600]">
            Sales Details
          </span>
          <div className="ChartSpanMonth_select">
            <div
              className="ChartSpanMonth_select_div"
              onClick={toDisplayAllMonths}
            >
              <img className="GraphAllDisplay" src={Grid} alt="All" />
            </div>
            <Select
              styles={customStyles}
              value={selectedOption}
              onChange={handleCalender}
              options={calender_options}
            />
          </div>
        </div>
        <Line
          data={
            specificMonth
              ? filteredData
              : diplayAllMonth
              ? salesData
              : salesData
          }
          options={options}
        />
      </div>
      <GraphContentsHover datas={hoveredData} />
    </div>
  );
}

export default SampleGraph;
